import { render, staticRenderFns } from "./memberdetail.vue?vue&type=template&id=6a408821&scoped=true&"
import script from "./memberdetail.vue?vue&type=script&lang=js&"
export * from "./memberdetail.vue?vue&type=script&lang=js&"
import style0 from "./memberdetail.vue?vue&type=style&index=0&id=6a408821&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a408821",
  null
  
)

export default component.exports